import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the TableSitebuilderView.
 * @extends JetView
 */
export default class TableSitebuilderView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the datatable
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                // Column definitions for the datatable
                                {
                                    id: 'detailTittle', // Column ID
                                    header: '', // Column header
                                    width: 60, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Detalles', // Tooltip text
                                    template: function (obj) {
                                        // Template function for rendering cell content
                                        return "<span class='webix_icon wxi-close details'></span>";
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: _('ID'), // Localized column header
                                    width: 75, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Username', // Column ID
                                    header: _('Nombre del usuario'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                    hidden: !devConfig.getPermAction(
                                        // Conditional visibility based on permissions
                                        'sensitiveInformationNames',
                                        'Add',
                                    ),
                                },
                                {
                                    id: 'Login', // Column ID
                                    header: _('Login'), // Localized column header
                                    width: 300, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DateCreated', // Column ID
                                    header: _('Fecha de creación'), // Localized column header
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 250, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting function
                                },
                                {
                                    id: 'Country', // Column ID
                                    header: _('País'), // Localized column header
                                    hidden: !devConfig.getPermAction(
                                        // Conditional visibility based on permissions
                                        'sensitiveInformationCountry',
                                        'Add',
                                    ),
                                    width: 150, // Column width
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                    editor: 'combo', // Editor type for inline editing
                                    options: [
                                        // Options for the combo editor
                                        { id: 1, value: _('Activo') },
                                        { id: 2, value: _('Inactivo') },
                                    ],
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                details: function (euv, id) {
                                    // Function to handle details click
                                    let item = this.getItem(id); // Get the clicked item
                                    webix
                                        .ui({
                                            // Create a new window UI
                                            view: 'window',
                                            id: 'updateUserSitebuilder', // ID for the window
                                            position: 'center', // Positioning of the window
                                            // Fullscreen mode based on screen width
                                            fullscreen: screen.width < 500 ? true : false,
                                            modal: true, // Modal window
                                            width: 500, // Window width
                                            head: {
                                                // Header configuration
                                                view: 'toolbar',
                                                cols: [
                                                    {
                                                        view: 'label',
                                                        label: _(
                                                            'Actualizar Usuario', // Localized label
                                                        ),
                                                        align: 'center', // Center alignment
                                                    },
                                                    {
                                                        view: 'icon',
                                                        icon: 'wxi-close', // Close icon
                                                        click: function () {
                                                            // Close button click handler
                                                            this.getTopParentView().hide(); // Hide the window
                                                        },
                                                    },
                                                ],
                                            },
                                            body: {
                                                // Body configuration of the window
                                                id: 'formUpdateUserSitebuilder', // ID for the form
                                                view: 'form', // Form view
                                                rows: [
                                                    // Form fields
                                                    {
                                                        id: 'Id', // Field ID
                                                        name: 'Id', // Field name
                                                        label: _('ID Usuario'), // Localized label
                                                        labelPosition: 'top', // Label position
                                                        sort: 'int', // Sorting type
                                                        disabled: true, // Field is disabled
                                                        view: 'text', // Text input
                                                        value: item.Id, // Default value
                                                    },
                                                    {
                                                        id: 'UserBackofficeId', // Field ID
                                                        name: 'UserBackofficeId', // Field name
                                                        label: _(
                                                            'Usuario backoffice', // Localized label
                                                        ),
                                                        labelPosition: 'top', // Label position
                                                        sort: 'int', // Sorting type
                                                        disabled: true, // Field is disabled
                                                        view: 'text', // Text input
                                                        value: item.UserBackofficeId, // Default value
                                                    },
                                                    {
                                                        view: 'text', // Text input
                                                        name: 'Username', // Field name
                                                        id: 'Username', // Field ID
                                                        css: 'my_input', // CSS class
                                                        label:
                                                            "<span class='icon-drivers-license-o'></span>" +
                                                            _(
                                                                'Nombre de usuario', // Localized label
                                                            ),
                                                        labelPosition: 'top', // Label position
                                                        disabled: true, // Field is disabled
                                                        value: item.Username, // Default value
                                                    },
                                                    {
                                                        view: 'text', // Text input
                                                        name: 'Login', // Field name
                                                        id: 'Login', // Field ID
                                                        css: 'my_input', // CSS class
                                                        label:
                                                            "<span class='icon-drivers-license-o'></span>" + _('Login'), // Localized label
                                                        labelPosition: 'top', // Label position
                                                        disabled: true, // Field is disabled
                                                        value: item.Login, // Default value
                                                    },
                                                    {
                                                        view: 'text', // Text input
                                                        name: 'NewPassword', // Field name
                                                        id: 'NewPassword', // Field ID
                                                        type: 'password', // Input type
                                                        css: 'my_input', // CSS class
                                                        label:
                                                            "<span class='icon-drivers-license-o'></span>" +
                                                            _(
                                                                'Nueva contraseña', // Localized label
                                                            ),
                                                        labelPosition: 'top', // Label position
                                                        invalidMessage: _(
                                                            'Mínimo 8 caracteres, una minúscula, una mayúscula y un número.', // Validation message
                                                        ),
                                                        validate: function (value) {
                                                            // Validation function
                                                            return (
                                                                value.length === 0 ||
                                                                (value.length >= 8 &&
                                                                    /[a-z]/.test(value) &&
                                                                    /[A-Z]/.test(value) &&
                                                                    /[0-9]/.test(value))
                                                            );
                                                        },
                                                        on: {
                                                            onBlur: function () {
                                                                // On blur event
                                                                $$('NewPassword').validate(); // Validate the field
                                                            },
                                                        },
                                                    },
                                                    {
                                                        view: 'text', // Text input
                                                        name: 'ConfirmNewPassword', // Field name
                                                        id: 'ConfirmNewPassword', // Field ID
                                                        type: 'password', // Input type
                                                        css: 'my_input', // CSS class
                                                        label:
                                                            "<span class='icon-drivers-license-o'></span>" +
                                                            _(
                                                                'Confirmar nueva contraseña', // Localized label
                                                            ),
                                                        labelPosition: 'top', // Label position
                                                        invalidMessage: _(
                                                            'Contraseñas no coinciden', // Validation message
                                                        ),
                                                        validate: function (value) {
                                                            // Validation function
                                                            return (
                                                                value == $$('NewPassword').getValue() // Check if passwords match
                                                            );
                                                        },
                                                        on: {
                                                            onBlur: function () {
                                                                // On blur event
                                                                $$('ConfirmNewPassword').validate(); // Validate the field
                                                            },
                                                        },
                                                    },
                                                    {
                                                        view: 'richselect', // Rich select input
                                                        name: 'State', // Field name
                                                        label: _('Estado'), // Localized label
                                                        labelPosition: 'top', // Label position
                                                        placeholder: _(
                                                            'Click para seleccionar', // Placeholder text
                                                        ),
                                                        options: [
                                                            // Options for the rich select
                                                            {
                                                                id: 1,
                                                                value: _(
                                                                    'Activo', // Localized value
                                                                ),
                                                            },
                                                            {
                                                                id: 2,
                                                                value: _(
                                                                    'Inactivo', // Localized value
                                                                ),
                                                            },
                                                        ],
                                                        value: item.State, // Default value
                                                    },
                                                    {
                                                        view: 'button', // Button for form submission
                                                        value: _('Actualizar'), // Localized button text
                                                        type: 'form', // Button type
                                                        click: function () {
                                                            // Click event handler
                                                            const newdata = $$('formUpdateUserSitebuilder').getValues(); // Get form values
                                                            if (
                                                                $$('formUpdateUserSitebuilder').validate() // Validate the form
                                                            ) {
                                                                if (newdata.NewPassword === '') {
                                                                    delete newdata.NewPassword; // Remove empty password
                                                                }
                                                                delete newdata.ConfirmNewPassword; // Remove confirm password
                                                                delete newdata.UserBackofficeId; // Remove backoffice ID
                                                                var vthis = this; // Reference to the button
                                                                webix
                                                                    .ajax() // AJAX request to update user
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'UserManagement/UpdateUserSitebuilder',
                                                                        newdata, // Data to send
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                // Error handler
                                                                                $$('UpdateUserSitebuilder').hide(); // Hide the window on error
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                // Success handler
                                                                                var data = JSON.parse(
                                                                                    text, // Parse response
                                                                                );
                                                                                if (
                                                                                    !data.HasError // Check for errors
                                                                                ) {
                                                                                    webix.message(
                                                                                        '¡Actualizacion exitosa!', // Success message
                                                                                    );
                                                                                } else {
                                                                                    webix.message({
                                                                                        title: '¡Error!', // Error title
                                                                                        type: 'alert-error', // Error type
                                                                                        text: _(
                                                                                            'ERROR' +
                                                                                                data.CodeError.toString(), // Error message
                                                                                        ),
                                                                                    });
                                                                                }
                                                                                $$('updateUserSitebuilder').hide(); // Hide the window after processing
                                                                            },
                                                                        },
                                                                    );
                                                            }
                                                        },
                                                    },
                                                ],
                                                elementsConfig: {
                                                    // Configuration for form elements
                                                    on: {
                                                        onChange: function () {
                                                            // Change event handler
                                                            this.validate(); // Validate the form on change
                                                        },
                                                    },
                                                },
                                            },
                                        })
                                        .show(); // Show the window
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'UserManagement/GetUserSitebuilder'; // API URL for fetching users
        var vthis = this; // Reference to the current instance
        var filter = ''; // Filter string
        this.on(this.app, 'requests:filter', (filterData) => {
            // Event listener for filter requests
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'DateCreated') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate over object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid = $$('datatable'); // Get the datatable instance
            grid.clearAll(); // Clear existing data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter string
        });
    }
}

// Custom UI component definition for imageLabel
webix.protoUI(
    {
        name: 'imageLabel', // Component name
        setValue: function (value) {
            // Function to set the image source
            this.setHTML(
                "<img style='width:100%;height: 100%;' src='" + value + "'>", // Set HTML content with image
            );
        },
    },
    webix.ui.label, // Base component
);

// FILE DOCUMENTED
